import {
  arrayOf as arrayType,
  bool as booleanType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

const HelpfulFeedbackResponse = {
  Errors: arrayType(stringType()),
  AuthorSubmissionToken: stringType(),
  HasErrors: booleanType(),
  Feedback: shapeType({
    FeedbackHelpfulness: shapeType({
      Vote: stringType(),
      AuthorId: stringType()
    }),
    FeedbackInappropriate: shapeType({
      ReasonText: stringType(),
      AuthorId: stringType()
    })
  })
};

export const dataModel = {
  submitReviewFeedback: params({
    id: stringType().isRequired(),
    feedbacktype: stringType(),
    contenttype: stringType().isRequired(),
    vote: stringType()
  })
    .mutation()
    .shape(HelpfulFeedbackResponse)
};
